import { ChapterModel } from '../../models/chapter.model';
import { StoryChapterThumbnail } from '../../models/story-chapter-thumbnail.model';
import { Patch } from 'src/vendor/immer-6.0.9/compat/pre-3.7/dist/immer';

export class StoryChaptersStateModel {
  loading: boolean;
  chapters: ChapterModel[];
  chaptersViewed: string[];
  selectedChapter: string;
  isChapterAnimated: boolean;
  thumbnails: Map<string, StoryChapterThumbnail>;
  patches: Patch[];
  inversePatches: Patch[];
}
